// extracted by mini-css-extract-plugin
module.exports = {"empty":"_2lkfQ8","paginationContainer":"_14sbr2"};